<template>
  <div><gabdlrzck /></div>
</template>

<script>
import gabdlrzck from '@/components/rizhi/gabdlrz'

export default {
  name: 'GabDlrz',
  components: {
    gabdlrzck
  },
  data() {
    return {}
  },
  created: function() {},
  methods: {}
}
</script>

<style scoped>
</style>
